import { Link } from "@tanstack/react-router";

import comparisLogo from "@/assets/comparis.png";
import hevLogo from "@/assets/hev-zuerich.png";
import logo from "@/assets/logo.png";
import svitLogo from "@/assets/svit-logo.png";
import { BRAND } from "@/lib/geo-config";

const MEMBERSHIPS = [
  { src: svitLogo, alt: "SVIT Zürich Mitglied", h: 26 },
  { src: hevLogo, alt: "HEV Zürich Mitglied", h: 26 },
  { src: comparisLogo, alt: "Comparis.ch Partner", h: 20 },
];

export function MembershipLogos({ dark = false }: { dark?: boolean }) {
  return (
    <ul className="flex flex-wrap items-center gap-x-6 gap-y-2">
      {MEMBERSHIPS.map((membership) => (
        <li key={membership.alt} className="flex items-center">
          <img
            src={membership.src}
            alt={membership.alt}
            loading="lazy"
            decoding="async"
            width={160}
            height={membership.h}
            style={{ height: `${membership.h}px` }}
            className={`w-auto object-contain grayscale transition-opacity hover:opacity-100 ${
              membership.src === svitLogo
                ? dark ? "opacity-75" : "brightness-0 opacity-60"
                : dark ? "brightness-0 invert opacity-60" : "opacity-50 brightness-[0.55]"
            }`}
          />
        </li>
      ))}
    </ul>
  );
}

export function SiteHeader({ regional = false }: { regional?: boolean }) {
  const sectionHref = (section: string) => (regional ? `/#${section}` : `#${section}`);

  return (
    <header className="sticky top-0 z-50 border-b border-border/60 bg-brand-dark/95 backdrop-blur">
      <div className="container-page flex h-16 items-center justify-between gap-4">
        <Link to="/" aria-label="Zur Startseite" className="flex shrink-0 items-baseline gap-1">
          <span className="text-lg font-semibold tracking-tight text-background sm:text-xl">
            immobilienwert<span className="text-primary">online</span>
          </span>
          <span className="hidden text-xs font-medium text-background/60 sm:inline">.ch</span>
        </Link>
        <nav aria-label="Hauptnavigation" className="hidden items-center gap-6 text-sm font-medium text-background/80 md:flex">
          <a href={sectionHref("markt")} className="transition hover:text-primary">Marktlage</a>
          <a href={sectionHref("referenzen")} className="transition hover:text-primary">Referenzen</a>
          <a href={sectionHref("stimmen")} className="transition hover:text-primary">Bewertungen</a>
          <a href={sectionHref("faq")} className="transition hover:text-primary">FAQ</a>
        </nav>
        <a
          href="#bewertung"
          className="rounded-full bg-primary px-4 py-2.5 text-center text-xs font-semibold text-primary-foreground transition hover:brightness-110 sm:px-5 sm:text-sm"
        >
          Immobilie bewerten
        </a>
      </div>
    </header>
  );
}

export function SiteFooter() {
  return (
    <footer className="bg-brand-dark-2 py-12 text-background/75">
      <div className="container-page flex flex-col gap-8 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <Link to="/" aria-label="Zur Startseite">
            <img src={logo} alt="PartNET AG" width={160} height={32} loading="lazy" className="h-8 w-auto" />
          </Link>
          <p className="mt-4 text-sm">{BRAND.address}</p>
          <p className="mt-1 text-sm">Wer den aktuellen Marktwert kennt, entscheidet besser – echter Marktwert 2026.</p>
        </div>
        <div className="text-sm sm:text-right">
          <a href="tel:+41445128512" className="font-medium text-background transition hover:text-primary">+41 44 512 85 12</a>
          <p className="mt-2">Immobilienbewertung in Stadt und Kanton Zürich</p>
          <nav aria-label="Rechtliche Informationen" className="mt-4 flex flex-wrap gap-4 sm:justify-end">
            <Link to="/impressum" className="transition hover:text-primary">Impressum</Link>
            <Link to="/datenschutz" className="transition hover:text-primary">Datenschutz</Link>
            <a href="/#regionen" className="transition hover:text-primary">Regionen &amp; Themen</a>
          </nav>
        </div>
      </div>
    </footer>
  );
}